// extracted by mini-css-extract-plugin
export default {"fourth":"Across_fourth__Zv4JM","img_div":"Across_img_div__2zQtS","text_container4":"Across_text_container4__uie-L"};